export const onSendWA = () => {
  const message: any = "Hallooo..., Saya tertarik untuk melakukan konsultasi.";
  const mobileNumber: any = "+6287895973284";
  // Regex expression to remove all characters which are NOT alphanumeric
  const number: any = mobileNumber.replace(/[^\w\s]/gi, "").replace(/ /g, "");

  // Track GA event if gtag function exists
  if (typeof window !== "undefined" && typeof (window as any).gtag === "function") {
    (window as any).gtag("event", "select_content", {
      content_type: "whatsapp_contact_button",
      item_id: "whatsapp_consultation",
      item_name: "Konsultasi WhatsApp",
      destination_url: `https://wa.me/${number}`,
    });
    (window as any).gtag("event", "click_whatsapp", {
      phone_number: mobileNumber,
    });
  }

  // Appending the phone number to the URL
  let url = `https://api.whatsapp.com/send?phone=${number}`;

  // Appending the message to the URL by encoding it
  url += `&text=${encodeURI(message)}&app_absent=0`;

  // Open our newly created URL in a new tab to send the message
  window.open(url, "_blank", "noopener,noreferrer");
};
